import React, { useEffect, useState } from "react";

const REFLECTIONS_IMG = "https://customer-assets.emergentagent.com/job_practice-portal-15/artifacts/2g9is1zu_sixteen-miles-out-GuWy7FSPLd8-unsplash.jpg";

const quotes = [
    "Healing isn't becoming someone new — it's remembering who you were before the world told you who to be.",
    "The moment you start asking who you are is the moment identity begins.",
    "Trauma may shape your story — but it doesn't get the final chapter.",
    "You survived what happened to you. Now you deserve to live.",
    "Feeling lost means you're ready to find your way.",
];

export default function Reflections() {
    const [i, setI] = useState(0);

    useEffect(() => {
        const id = setInterval(() => setI((p) => (p + 1) % quotes.length), 6500);
        return () => clearInterval(id);
    }, []);

    return (
        <section id="reflections" data-testid="reflections-section" className="py-28 lg:py-40" style={{ background: "#EEF2ED" }}>
            <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    <div className="lg:col-span-5" data-reveal>
                        <img
                            src={REFLECTIONS_IMG}
                            alt="Peonies in soft natural light"
                            className="w-full h-[420px] lg:h-[560px] object-cover"
                        />
                    </div>

                    <div className="lg:col-span-7" data-reveal>
                        <span className="editorial-eyebrow">Reflections</span>
                        <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-charcoal">
                            Words to <em className="italic text-gold">return to.</em>
                        </h2>

                        <div className="mt-10 hairline" />

                        {/* Quote carousel with gold left border */}
                        <div
                            className="mt-12 min-h-[180px] sm:min-h-[200px] relative"
                            data-testid="reflections-carousel"
                            style={{ borderLeft: "3px solid #9B7D5A", paddingLeft: "20px" }}
                        >
                            {quotes.map((q, idx) => (
                                <blockquote
                                    key={idx}
                                    className={`absolute inset-0 transition-opacity duration-1000 ${
                                        idx === i ? "opacity-100" : "opacity-0 pointer-events-none"
                                    }`}
                                    style={{ paddingLeft: "20px" }}
                                    aria-hidden={idx !== i}
                                >
                                    <p className="font-serif italic text-3xl sm:text-4xl lg:text-5xl leading-[1.2] text-charcoal text-pretty">
                                        <span className="text-gold mr-2">"</span>
                                        {q}
                                        <span className="text-gold ml-2">"</span>
                                    </p>
                                </blockquote>
                            ))}
                        </div>

                        {/* Dots */}
                        <div className="mt-10 flex items-center gap-3" data-testid="reflections-dots">
                            {quotes.map((_, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => setI(idx)}
                                    aria-label={`Reflection ${idx + 1}`}
                                    data-testid={`reflection-dot-${idx}`}
                                    className={`h-px transition-all duration-500 ${
                                        idx === i ? "w-12 bg-gold" : "w-6 hover:bg-gold"
                                    }`}
                                    style={idx === i ? {} : { background: "#E2DDD8" }}
                                />
                            ))}
                        </div>

                        <p className="mt-14 text-sm text-charcoal-soft/70 italic max-w-md">
                            In honor of Wisconsin licensing board ethics, we do not publish client testimonials.
                            These are reflections — gathered from the work, in care for the people who do it.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
